module.exports = __webpack_public_path__ + "img/asobikata.3aaf3d8c.png";